<template>
  <list>
    <div class="item-header">
      {{ $l.infoFromCompany }}
    </div>

    <info-cell
      v-for="(info, index) in infos"
      :key="index"
      :info="info"
      />
  </list>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'
import InfoCell from '@/components/Home/InfoCell'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    List,
    InfoCell
  },

  created: async function () {
    await this.$store.dispatch('info/retrieveInfos')
  },

  computed: {
    infos: function () {
      return this.$store.state.info.infos
    }
  }
}
</script>
